const t = {
  name: "SortDescending",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5H13V7H2V5Z" fill="currentColor"/>
<path d="M2 17H10V19H2V17Z" fill="currentColor"/>
<path d="M10 11H2V13H10V11Z" fill="currentColor"/>
<path d="M16 16.5859L12.9999 13.5858L11.5857 15L16.9999 20.4142L22.4141 15L20.9999 13.5858L18 16.5857V5H16V16.5859Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SortDescending
};
